/**
 * Single source of truth for the Expense & Save application version.
 *
 * To bump the version, edit ONLY this file. Every UI surface (About page,
 * sidebar footer, and any future About/Settings component) reads from here.
 *
 * The value is also mirrored into `frontend/package.json` `version` for
 * npm-tooling consistency, but the UI never reads from package.json at
 * runtime — this constant is the canonical value.
 */
export const APP_VERSION = "5.0.0";

/** Formatted for display, e.g. "Version 5.0.0". */
export const APP_VERSION_LABEL = `Version ${APP_VERSION}`;
